import { cn } from '@/lib/utils'
import { cva, VariantProps } from 'class-variance-authority'
import * as React from 'react'

export type InputProps = React.InputHTMLAttributes<HTMLInputElement> & InputVariantProps
export type InputVariantProps = VariantProps<typeof inputVariants>

export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  ({ className, type, error, variant, text, ...props }, ref) => (
    <input
      tabIndex={0}
      type={type}
      className={cn(inputVariants({ error, variant, text }), className)}
      ref={ref}
      {...props}
    />
  ),
)
Input.displayName = 'Input'

export const inputVariants = cva(
  'flex w-full items-center font-light text-lg justify-between rounded border px-3 -outline-offset-1 focus:outline focus:outline-2 disabled:cursor-not-allowed disabled:opacity-50',
  {
    variants: {
      variant: {
        default: 'bg-neutral-25 border-neutral-150 text-neutral-500 placeholder:text-neutral-150',
        gray: 'bg-neutral-25 placeholder:text-neutral-150 text-grey-400',
        black: 'bg-neutral-600 text-white placeholder:text-white border-transparent',
      },
      error: {
        true: 'border-error-300 focus:outline-error-300',
      },
      height: {
        fixed: 'h-10 whitespace-nowrap',
        auto: 'max-h-[400px] min-h-16',
      },
      text: {
        sm: 'text-sm',
        md: 'text-base',
      },
    },
    defaultVariants: {
      variant: 'default',
      height: 'fixed',
      text: 'md',
      error: false,
    },
    compoundVariants: [
      {
        variant: 'gray',
        error: false,
        className: `border-neutral-150 focus:outline-neutral-500`,
      },
      {
        variant: 'default',
        error: false,
        className: `border - grey - 150 focus:outline-neutral-500`,
      },
    ],
  },
)
